import React from 'react';
import T from 'components/T';
import CandidateStoryItemTextField from '../Common/CandidateStoryItemTextField';

type Props = {
  company: string;
  disabled?: boolean;
  field: string;
};

const GeneralInformationTextForm = ({
  company,
  disabled = false,
  field,
}: Props) => {
  return (
    <div
      className='cp-form-group'
      data-testid='general-information-text-form'
      hidden={disabled}
    >
      <p>
        <T
          value='components.Report.CandidateStories.Modal.GeneralInformation.pleaseShare'
          company={company}
          dangerousHTML
        />
      </p>

      <ul className='text-muted'>
        <T value='components.Report.examples' />
        <li>
          <T
            value='components.Report.CandidateStories.Modal.GeneralInformation.example1'
            company={company}
          />
        </li>
        <li>
          <T value='components.Report.CandidateStories.Modal.GeneralInformation.example2' />
        </li>
        <li>
          <T value='components.Report.CandidateStories.Modal.GeneralInformation.example3' />
        </li>
        <li>
          <T value='components.Report.CandidateStories.Modal.GeneralInformation.example4' />
        </li>
      </ul>

      <CandidateStoryItemTextField field={field} />
    </div>
  );
};

export default GeneralInformationTextForm;
